import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { PrivatePolicyDialogComponent } from '../../shared/components/dialogs/private-policy-dialog/private-policy-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-consent-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    MatButton,
    MatCheckbox,
    FormsModule,
  ],
  templateUrl: './consent-form.component.html',
  styleUrl: './consent-form.component.scss',
})
export class ConsentFormComponent {
  translateService: TranslateService = inject(TranslateService);
  router: Router = inject(Router);
  dialog: MatDialog = inject(MatDialog);
  route: ActivatedRoute = inject(ActivatedRoute);
  
  agreeChecked: boolean = false;
  consentForm!: FormGroup;

  ngOnInit() {
    this.consentForm = new FormGroup({
      agreeChecked: new FormControl(false, [Validators.requiredTrue]),
    });

    this.consentForm.get('agreeChecked')?.valueChanges.subscribe(
      (checked: boolean) => {
        this.agreeChecked = checked;
      }
    )
  }

  openPrivacyPolicy() {
    const privacyPolicyDialog = this.dialog.open(PrivatePolicyDialogComponent, {
      data: {
        title: this.translateService.instant(
          'consent-form.privacy-policy-title'
        ),
        message: '',
        buttonText: this.translateService.instant('consent-form.privacy-policy-button'),
        showCloseButton: false,
        action: () => privacyPolicyDialog.close(),
      },
    });

    privacyPolicyDialog.afterClosed().subscribe(result => {
      if (result === 'agree') {
        this.consentForm.get('agreeChecked')?.setValue(true, { emitEvent: false });
        this.agreeChecked = true;
      }
    });
  }

  onSubmit() {
    if (this.dialog.openDialogs.length > 0) return;
    if (this.consentForm.valid) {
      const queryParams: Record<string, string> = {
          'setting-source': 'create',
        };
      const backToAppointment =
        this.route.snapshot.queryParamMap.get('backToAppointment');
      if (backToAppointment) queryParams['backToAppointment'] = 'true';
      this.router.navigate(['/healthcheck/passwordset'], { queryParams }).then();
    }
  }
  
}
